import { Typography } from '@recruit-robin/robin-theme/web-components';
import { useContext } from 'react';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';

import { Check } from '@recruit-robin/robin-theme/web-icons';
import { useStyles } from './RJCommHubJobAlertsConfirmation.styles';

export const RJCommHubJobAlertsConfirmation = () => {
  const { dictionary } = useContext(LocalizationContext);

  const classes = useStyles();

  return (
    <div css={classes.wrapper}>
      <div css={classes.root}>
        <div css={classes.iconContainer}>
          <Check size={24} />
        </div>
        <div css={classes.textContainer}>
          <Typography variant={(v) => v.heading[3]} color={(c) => c.neutral.variant[80]}>
            {dictionary.jobAlertsActivated}
          </Typography>
          <Typography variant={(v) => v.body.short} color={(c) => c.neutral.variant[70]}>
            {dictionary.wellKeepYouUpdatedWithMoreJobOpportunities}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default RJCommHubJobAlertsConfirmation;
